<script>
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import {useSecurityStore} from "@/stores/Security.js";
import {usePersonalizedVariableStore} from "@/stores/Edms/PersonalizedVariable.js";
import axios from "axios";
import {watch} from "vue";

export default {
    setup() {
        const {
            loading,
            total,
            filter,
        } = useSharedData();

        const {transformFilterValues} = useSharedMethod();

        const {$router, $i18n} = useTools();

        const personalizedVariableStore = usePersonalizedVariableStore();
        const securityStore = useSecurityStore();

        const headers = [
            {
                text: "...",
                sortable: false,
                align: "left",
                value: "action",
                width: "0%",
            },
            {
                text: $i18n.t("common.name"),
                align: "left",
                value: "name",
                sortable: true,
                width: "0%",
            },
            {
                text: $i18n.t("common.module"),
                align: "left",
                value: "module",
                sortable: true,
                width: "0%",
            },
            {
                text: $i18n.t("common.type"),
                align: "left",
                value: "type",
                sortable: true,
            },
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_DOCUMENT_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'personalized_variables.edit', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_DOCUMENT_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'personalized_variables.delete', params: {id: item.id}})
                },
            }
        ];

        function findAll() {
            loading.value = true;
            axios.get('/personalizedVariables', {params: transformFilterValues(filter.value)}).then((response) => {
                personalizedVariableStore.setPersonalizedVariables(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }



        function view(item) {
            $router.push({name: 'personalized_variables.view', params: {id: item.id}});
        }

        watch(() => filter.value, () => {
            findAll();
        }, {deep: true, immediate: true});


        return {
            personalizedVariableStore,
            securityStore,
            headers,
            actions,
            loading,
            total,
            filter,
            findAll,
            view,
        };
    },
}
</script>

<template>
    <div>
        <w-app
            :title="$t('module.personalized_variable')"
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_DOCUMENT_PARAM']"
                    @press="$router.push({name: 'personalized_variables.add'})"
                />
            </template>

            <template v-slot:content>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :items="personalizedVariableStore.personalizedVariables"
                    :total="total"
                    :loading="loading"
                    sort-by="name"
                    @rowDbClick="view"
                >
                    <template v-slot:item.name="{ item }">
                        <w-inline-text bold :text="`[#${item.name}#]`"/>
                    </template>
                    <template v-slot:item.module="{ item }">
                        <w-inline-text :text="$t(`modules.${item.module}`)"/>
                    </template>
                    <template v-slot:item.type="{ item }">
                        <w-inline-text :text="$t(`personalized_variable.type.${item.type}`)"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>